import React from 'react';
import { useRef } from 'react';
import { getOfferletterData, postOfferletterData, updateOfferletterData } from '../../service/adminApi';
import { uploadBackend } from '../../utils/Upload';
import { OnlySpecialChar, OnlyNumber } from '../../utils/RegHandling';

function OfferletterForm({ handleData, editData, hideContainer }) {
    const fileInput = useRef(null);

    let defaultValue = {
        title: '',
        location: '',
        attachment_url: '',
    };

    let defaultErrorValue = {
        titleError: '',
        locationError: '',
        attachmentError: '',
    };

    const [offerLetterDetails, setOfferLetterDetails] = React.useState(defaultValue);
    const [offerLetterErrorDetails, setOfferLetterErrorDetails] = React.useState(defaultErrorValue);
    const [offerLetterName, setOfferLetterName] = React.useState('');
    const [attachmentValidation, setattachmentValidation] = React.useState('');

    React.useEffect(() => {

        if (editData?.id !== undefined) {
            let filename = editData.attachment_url.split('/');
            filename = filename[filename.length - 1];
            setOfferLetterDetails(editData);
            setOfferLetterName(filename);
        }
    }, [editData]);

    const addOfferLetter = async () => {
        
        let dirName = `Offer-letter`;
        let file = fileInput?.current?.files[0];
        if (validateOfferDetails(offerLetterName)) {
            let data = {
                title: offerLetterDetails.title,
                location: offerLetterDetails.location,
                attachment_url: offerLetterDetails.attachment_url,
            };

            let response = '';
            if ((editData?.id === undefined || editData?.id === '') && attachmentValidation == '') {
                let newFileName = fileInput.current.files[0].name;
                let fileData = await uploadBackend(file, newFileName,dirName);
                data['attachment_url'] = fileData;
                response = await postOfferletterData(data);
            } else if (attachmentValidation == '') {
                data['id'] = offerLetterDetails.id;
                if (fileInput.current.files.length > 0) {

                    let newFileName = fileInput.current.files[0].name;
                    let fileData = await uploadBackend(file, newFileName,dirName);
                    data['attachment_url'] = fileData;
                }
                response = await updateOfferletterData(data);
            }
            if (response.data.statusCode === 200) {
                handleData('update');
                setOfferLetterDetails(defaultValue);
                setOfferLetterName('');
                hideContainer();
            }
        }
    };

    const validateOfferDetails = (file) => {
        let result = true;
        if (offerLetterDetails.title === undefined || offerLetterDetails.title === '') {
            setOfferLetterErrorDetails((offerLetterDetails) => ({ ...offerLetterDetails, titleError: 'Title is required' }));
            result = false;
        }
        if (!OnlyNumber(offerLetterDetails.title) || !OnlySpecialChar(offerLetterDetails.title)) {
            setOfferLetterErrorDetails((offerLetterDetails) => ({ ...offerLetterDetails, titleError: 'Title is required' }));
            result = false;
        }
        if ((file === undefined || file === '') && attachmentValidation == '') {
            setOfferLetterErrorDetails((offerLetterDetails) => ({ ...offerLetterDetails, attachmentError: 'Attachment is required' }));
            result = false;
        }

        return result;
    };

    const setOfferLetterData = (e) => {
        setOfferLetterDetails((offerLetterDetails) => ({
            ...offerLetterDetails,
            [e.target.name]: e.target.value,
        }));
    };

    const getFileName = (e) => {
        setOfferLetterName(e.target.files[0].name);
        setOfferLetterErrorDetails((offerLetterDetails) => ({ ...offerLetterDetails, attachmentError: '' }));
        if (e.target.files[0].size >= 1000000) {
            setattachmentValidation('File size should be less than 1MB');
            return false;
        } else {
            setattachmentValidation('');
        }
        const typeArr = ['pdf'];
        let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
        if (type == false) {
            setattachmentValidation('The uploaded file should be in pdf format');
            return false;
        } else {
            setattachmentValidation('');
        }
    };

    const resetData = () => {
        setOfferLetterDetails(defaultValue);
        setOfferLetterErrorDetails(defaultErrorValue);
        setOfferLetterName('');
        handleData('cancel');
        hideContainer();
    };

    return (
        <div>
            <div className="offcanvas-header">
                <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                    {editData?.id !== undefined ? `Edit` : `New`} Offer Letter
                </h5>
                <button
                    onClick={() => {
                        resetData();
                    }}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>
            <div className="offcanvas-body">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="col-md-12 mt-4">
                            <label className="form-label hive-form-label" htmlFor="Announcement-Title">
                                Title
                                <span className="hive-form-mandatory">*</span>
                            </label>
                            <input
                                type="text"
                                className="col-md-6 form-control hive-form-control"
                                id="Announcement-Title"
                                placeholder="Enter a title for offer letter"
                                value={offerLetterDetails.title}
                                onChange={(e) => {
                                    setOfferLetterErrorDetails((offerLetterErrorDetails) => ({
                                        ...offerLetterErrorDetails,
                                        titleError: '',
                                    }));
                                    setOfferLetterData(e);
                                }}
                                name="title"
                            />
                            <span className="text-danger tt-bold font-12">{offerLetterErrorDetails.titleError}</span>
                        </div>
                        <div className="col-md-12">
                            <label className="form-label col-md-6 hive-form-label mt-4" htmlFor="Announcement-Title">
                                Office Location
                                <span className="hive-form-mandatory">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control hive-form-control"
                                id="Announcement-Title"
                                value={offerLetterDetails.location}
                                placeholder="Enter the Office Location"
                                onChange={(e) => {
                                    setOfferLetterErrorDetails((offerLetterErrorDetails) => ({
                                        ...offerLetterErrorDetails,
                                        locationError: '',
                                    }));
                                    setOfferLetterData(e);
                                }}
                                name="location"
                            />
                            <span className="text-danger tt-bold font-12">{offerLetterErrorDetails.locationError}</span>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <label className="form-label hive-form-label w-100">
                            Attachment
                            <span className="hive-form-mandatory">*</span>
                            <span>
                                <img
                                    src="/Images/help.svg"
                                    class="ps-2"
                                    alt="Evaluation info"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={
                                        'If any document need to attach regarding the relieving and Upload document Format should be in doc or Pdf'
                                    }
                                />
                            </span>
                        </label>
                        <label for="voterid-upload" className="custom-file-upload-styles">
                            <img className="m-2" src="/Images/top-up.svg" alt="" />
                            Upload
                        </label>
                        <input
                            ref={fileInput}
                            id="voterid-upload"
                            onChange={(e) => {
                                setOfferLetterErrorDetails((offerLetterErrorDetails) => ({
                                    ...offerLetterErrorDetails,
                                    attachmentError: '',
                                }));
                                getFileName(e);
                            }}
                            type="file"
                            className="custom-file-upload-btn"
                            name="attachment_url"
                        />
                    </div>
                    <span className="text-primary tt-bold font-12">{offerLetterName}</span>
                    <span className="text-danger tt-bold font-12">{offerLetterErrorDetails.attachmentError}</span>
                    {attachmentValidation ? <span className="text-danger tt-bold font-12">{attachmentValidation}</span> : null}
                    <div className="d-flex justify-content-end mb-4 p-3 custom-button-position ">
                        <button
                            className="btn hive-btn-secondary me-3"
                            data-bs-dismiss="offcanvas"
                            onClick={() => {
                                resetData();
                            }}
                            aria-label="Close"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                addOfferLetter();
                            }}
                            className="btn hive-btn-primary"
                            type="sumbit"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            {editData?.id !== undefined ? `Update` : `Add`} Offer Letter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OfferletterForm;
